<template>
    <div class="h-100">
        <app-loader v-if="pageLoader"></app-loader>
        <div class="advanced-seat-tab-content-header trading-chart-header wt-dashborad-chart-header d-flex justify-content-end align-items-center mt-4 mb-2">
            <!-- <div class="wt-dashborad-chart-footer mt-3 mb-2">
                <ul class="d-flex align-items-center p-0" id="myTab" role="tablist">
                    <li class="nav-item" v-for="(profit_j,index) in profitJson" :key="index">
                        <a class="nav-link"   v-bind:class="{'active':tradingProfitTab == index}"  href="javascript:void(0);" role="tab" aria-controls="usd"
                            @click="changeTradingProfitTab(index)"
                        >{{ index }}</a>
                    </li>
                </ul>
            </div> -->
            <div class="dropdown dark-dropdown">
                <button class="btn dropdown-toggle f-14" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ tradingFilter }}
                </button>
                <div class="dropdown-menu mt-1 w-100" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item" href="javascript:void(0);" v-text="performance" v-for=" (performance,index)  in tradingPairFilter" :key="index" @click="setTradingFilter(performance)"></a>
                </div>
            </div>
        </div>
        <div v-show="(Object.keys(portfolioChartData).length && portfolioChartData.series.length && portfolioChartData.series[0].data.length) ">
            <div id="trader_portfolio" class="portfolio"></div>
        </div>
        <div v-if="!(Object.keys(portfolioChartData).length && portfolioChartData.series.length && portfolioChartData.series[0].data.length) " class="nodataFound position-relative">
            <div class="boxedNodata d-flex align-items-center justify-content-center">
                <div class="noDataPic">
                    <img src="../../../../../../static/website/images/no-data.svg" alt="" />
                    <!-- <span class="f-16">No trading history found.</span> -->
                </div>
            </div>
            <!-- <img src="../../../../../static/hanko/images/new/errorGraphCandle.png" alt="graph" />  -->
        </div>
        <div class="d-flex justify-content-between align-items-center mt-3 mb-2 " v-if="(Object.keys(portfolioChartData).length && portfolioChartData.series.length && portfolioChartData.series[0].data.length) ">
            <div class="wt-dashborad-chart-footer ">
                <ul class="d-flex align-items-center p-0">
                    <li v-for="item,key in dateDrop" @click.prevent.stop="dateDropSelected = key" :class="{'active':dateDropSelected == key}">{{ item }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import * as am4core from "../../../../../../node_modules/@amcharts/amcharts4/core"
import * as am4charts from "../../../../../../node_modules/@amcharts/amcharts4/charts"
import am4themes_animated from "../../../../../../node_modules/@amcharts/amcharts4/themes/animated"

import { commonAllmixins } from "@/plugins/commonAll";
export default {
    emits:['updateSelectedTimeFrame'],
    props:['dateDrop','dateDropSelected'],
    mixins: [commonAllmixins],
    data:function(){
        return {
            tradingProfitTab : 'USD',
            profitJson : {
                'USD' : 'USD',
                'Pips' : 'pips',
                // 'ROI' : '%'
            },
            tradingFilter : 'Pairs',
            tradingPairFilter:{
                1: 'Pairs',
                2 : 'Trading Timezone'
            },
            xAxisColor:'#666666',
            yAxisColor:'#404d7b',
            leader_id:'',
            pageLoader : false,
            chart:null
        }
    },
    watch:{
        'dateDropSelected':function(){
            this.getTradingData();
        }
    },
    mounted(){
        this.getTradingData();
    },
    methods:{
        setTimeframe(date_drop){
            this.$emit('updateSelectedTimeFrame',date_drop)
        },
        drawTradingChartData1(){
                this.destroyChart();
                var root = am5.Root.new("trader_portfolio");
                let themes = [
                    am5themes_Animated.new(root),
                    am5themes_Responsive.new(root)
                ];

                // if(this.auth_store.mode == 'dark'){
                //     themes.push(am5themes_Dark.new(root));
                // }

                root.setThemes(themes);


                // Create chart
                var chart = root.container.children.push(am5percent.PieChart.new(root, {
                    layout: root.verticalLayout
                }));

                var series = chart.series.push(am5percent.PieSeries.new(root, {
                    valueField: "y",
                    categoryField: "x",
                }));
                series.ticks.template.disabled = true;
                series.alignLabels = false;
                series.labels.template.fill = am4core.color("white");
                series.get("colors").set("colors", [
                    am5.color(0x4572a7),
                    am5.color(0xCBCBCB),
                    am5.color(0x69cd4b),
                    am5.color(0xff6f34),
                    am5.color(0xf6f819),
                    am5.color(0x8dedc8),
                    am5.color(0x8dedc8),
                    am5.color(0x404d7b),
                    am5.color(0x404d7b),
                ]);
                series.data.setAll(this.portfolioChartData.series[0].data);
                series.slices.template.set("tooltipText", "{x}: {y}");
                series.slices.template.set("toggleKey", "none");
                series.labels.template.setAll({
                    text: "{x}",
                    radius: 10,
                    fontSize: 12,
                    fontWeight: "600",
                });
                series.appear(1000, 100);
        },
        drawTradingChartData() {
            // Destroy existing chart instance if any
            this.destroyChart();

            // Create chart instance
            let chart = am4core.create("trader_portfolio", am4charts.PieChart);

            // Set themes
            am4core.useTheme(am4themes_animated);
            // if (this.auth_store.mode == 'dark') {
            //     am4core.useTheme(am4themes_dark);
            // }

            // Create series
            let series = chart.series.push(new am4charts.PieSeries());
            series.dataFields.value = "y";
            series.dataFields.category = "x";

            // Set colors
            // series.colors.list = [
            //     am4core.color(0x4572a7),
            //     am4core.color(0xCBCBCB),
            //     am4core.color(0x69cd4b),
            //     am4core.color(0xff6f34),
            //     am4core.color(0xf6f819),
            //     am4core.color(0x8dedc8),
            //     am4core.color(0x8dedc8),
            //     am4core.color(0x404d7b),
            //     am4core.color(0x404d7b),
            // ];

            // Set data
            series.data = this.portfolioChartData.series[0].data;
            series.ticks.template.disabled = true;
            series.alignLabels = false;
            series.labels.template.fill = am4core.color("white");
            // Configure slices
            series.slices.template.tooltipText = "{x}: {y}";
            series.slices.template.propertyFields.fill = "color";

            // Configure labels
            series.labels.template.text = "{x}";
            series.labels.template.radius = 10;
            series.labels.template.fontSize = 12;
            series.labels.template.fontWeight = "600";

            series.slices.template.states.getKey("active").properties.shiftRadius = 0;
            series.slices.template.states.getKey("hover").properties.shiftRadius = 0;

            // Animate the chart
            series.hiddenState.properties.opacity = 1;
            series.hiddenState.properties.endAngle = -90;
            series.hiddenState.properties.startAngle = -90;

            chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
        },

        getTradingData(){
            let formData = {};
            let type = ''
            if(this.tradingFilter == 'Pairs'){
                type = 'CURRENCY_COUNT'
            }else {
                type = 'CURRENCY_TIMEZONE'
            }
            this._runGetPortfolioChartData({ globalParams: {}, localParams: { provider_id: this.divide9(this.$route.query.id), type: type, timeframe: this.dateDropSelected, parameter: this } })
        },

        setTimeframe(date_drop){
            this.$emit('updateSelectedTimeFrame',date_drop)
        },
        destroyChart(){
            let chartElement = am4core.registry.baseSprites.find((sprite) => sprite.htmlContainer.id === "trader_portfolio");
            if (chartElement) {
                chartElement.dispose();
            }
        },
        setTradingFilter(trading){
            if(this.tradingFilter != trading){
                this.tradingFilter = trading;
                this.getTradingData();
            }

        },
        changeTradingProfitTab(tab){
            this.tradingProfitTab = tab;
            this.getTradingData();
        }
    }
}
</script>


<style>
    /* .portfolio{
        height: 400px;
        width: 100%;
    } */
</style>


// WEBPACK FOOTER //
// src/components/website/copy-trade/leader-detail/Charts/trading-chart.vue